import React from 'react';
import PoliceLogo from '@/assets/police.png';

const Footer: React.FC = () => {
  return (
    <footer
      style={{
        textAlign: 'center',
        padding: '24px',
        backgroundColor: '#EBE5D9',
      }}
    >
      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          gap: '40px',
        }}
      >
        <a
          href="https://beian.miit.gov.cn"
          target="_blank"
          rel="noopener noreferrer"
          style={{ color: '#666', textDecoration: 'none', fontSize: '14px' }}
        >
          晋ICP备2026006006号-1
        </a>
        <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
          <img
            src={PoliceLogo}
            alt="police"
            style={{ width: '16px', height: '16px' }}
          />
          <a
            href="https://www.beian.gov.cn"
            target="_blank"
            rel="noopener noreferrer"
            style={{ color: '#666', textDecoration: 'none', fontSize: '14px' }}
          >
            晋公网安备14080202191978号
          </a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
